const texts = {
    test: "test!",
    authorizationTabs: {
        signIn: "Sign In",
        signUp: "Sign up",
    },
    general: {
        save: "Save",
        close: "Close",
        next: "Next",
        clearStep: "Clear this step",
        tryAgain: "Try again",
        errorTitle: "Error",
        service: "Service:",
        message: "Message:",
        statusCode: "Status code:",
    },
    months: {
        1: "January",
        2: "February",
        3: "March",
        4: "April",
        5: "May",
        6: "June",
        7: "July",
        8: "August",
        9: "September",
        10: "October",
        11: "November",
        12: "December",
    },
    signIn: {
        title: "Welcome to MultiMatch",
        description: "Create your own customized Controlled Release Fertilizer (CRF) solution",
        email: "E-Mail",
        password: "Password",
        forgotPassword: "Forgot password?",
        keepMeLoggedIn: "Keep me logged in from this computer",
        keepMeLoggedInMobile: "Keep me logged in from this device",
        emailApproved: "Your email has been approved\nplease login to proceed",
    },
    updatePassword: {
        title: "Set new password",
        description: "Your password should have",
        password: "New password",
        confirmPassword: "Confirm password",
        submitMessage: "Update password",
        success: "Your password has changed, redirecting to login page.",
        UPDATE_PASSWORD_CONFIRMED: "Your password has been confirmed successfully",
        errors: {
            EMAIL_TOKEN_INVALID: "Your password reset token is invalid",
            EMAIL_NOT_CONFIRMED: "Your email address has not been confirmed.",
            MAIL_NOT_CONFIRMED: "Your email address has not been confirmed.",
            PASSWORD_UPDATE_SUCCESS: "Your password has been updated ",
            PASSWORD_UPDATE_FAILED: "Your password has fail to update",
            TEMP: "Invalid token or email not confirmed",
        },
        sendEmail: "We have sent an email\nGo check your inbox :)",
        errorPasswordRequired: "Password and confirm password must be not empty",
    },
    signUp: {
        note: "Sign up to save your information for future use",
        passwordNote: "Your password should have a minimum 8 characters contains a uppercase letter, lowercase and number.",
        fullName: "Full name",
        country: "Country",
        region: "Region",
        email: "E-mail",
        mainInterest: "Main interest",
        expertise: "Expertise",
        password: "Password",
        confirmPassword: "Confirm password",
        iAccept: "I accept",
        termsAndConditions: "Haifa's terms & conditions",
        and: "and",
        privacyPolicy: "Privacy Policy",
        next: "Next",
        emailSent: "We have sent an email to {0}\nGo check your inbox :)",
        didntGet: "Didn't get it?",
        checkBoxError: "Please Approve",
    },
    validationErrors: {
        //-------login and registration ------------------ //
        fieldIsRequired: "Mandatory fields must be filled",
        incorrectEmailFormat: `Email address doesn't exist`,
        passwordValidation: "Invalid password",
        passwordsDontMatch: `Passwords doesn't match`,
        lettersOnly: "Please use letters only",
        incorrectEmail: "Incorrect email address",
        IncorrenctPassword: "Incorrect password",
        emailExisted: "Email address already exists in the system",
        termsCheckbox: "Required",
        //------------------------------------------------
        valueOutOfRange: "Value must be between {0} and {1}",
        invalidDateFormat: "Please enter a valid date",
        dateMustBeGreater: "Harvest date must be greater than planting",
        dateMustBeAtLeastTwoMonths: "The dates must be at least two months",
        noServiceForSpecificCountry: "No service is provided for the selected country",
        dateMaxDatesTwelveMonth: "Maximum is one year.",
    },
    errorMessages: {
        generic: "An error occurred, please try again later",
        LOGIN_FAILED: "The username or password is incorrect",
        MISSING_EMAIL: "Email is required.",
        EMAIL_INVALID: "Incorrect email address",
        DUPLICATEUSERNAME: "This email address already exists in the system",
        PASSWORD_INVALID: "Invalid password",
        USERNAME_INVALID: `Name can't contain special characters or numbers`,
        SPECIALIZATION_INVALID: "Invalid Specialization",
        MAIN_INTEREST_INVALID: "Invalid main interest",
        REGION_INVALID: "Invalid region",
        REGION_NOT_EXIST: "Region not exist",
        USER_NOT_FOUND: "User not exist",
        USER_ALREADY_EXIST: "User already exist",
        MISSING_VALUES_TO_CONFIRM_REGISTRATION: "Registration failed - you are missing values",
        EMAIL_SENT_TO_USER: "E-mail has been sent to user",
        REGISTRATION_FAILED: "Registration failed",
        TOKEN_INVALID: "Authentication token invalid",
        EMAIL_CONFIRMED_ALREADY: "E-mail address has been confirmed already",
        NO_SOLUTION_MATCH: "No ready-made shelf solution has been found",
        EMAIL_CONFIRMED_SUCCESS: "E-mail has been confirmed successfully",
        VALIDATION_FAILED: "Validation has been failed",
        ACCEPT_TERMS_INVALID: "Invalid accept terms value",
        SAVING_ITEM_FAILED: "Failed to save item",
        SAVED_ITEM_NOT_FOUND: "Item not exist",
        UPDATING_RECIPE_ITEM_FAILED: "Failed to update item",
        REMOVING_RECIPE_ITEMS_FAILED: "Failed to delete recipe item",
        REMOVING_GRAPH_ITEMS_FAILED: "Failed to delete graph item",
        ITEM_UPDATED_SUCCESSFULLY: "Item has been updated successfully",
        ITEM_DELETED_SUCCESSFULLY: "Item has been deleted successfully",
        RAW_MATERIAL_PARAMETERS_NOT_VALID: "Failed to save new raw material - Invalid parameters",
        SAVING_RAW_MATERIAL_FAILED: "Failed to save new raw material",
        RAW_MATERIAL_ALREADY_EXIST: "Raw material already exist",
        REMOVING_ITEM_FAILED: "Failed to delete item",
        UPDATING_ITEMS_FAILED: "Error in updating item in DB",
        CALCULATOR_IS_NOT_READY: "Calculator data Loading..",
        NUTRIENT_TYPE_INVALID: "Nutrient type invalid",
        BLEND_INVALID: "Invalid multicote blend",
        TYPE_INVALID: "type invalid for one of the properties",
        MISSING_SAVED_ITEM_ID: "Missing saved item id in request",
        ITEM_NOT_FOUND: "Item not found",
        RECIPE_TOTAL_ITEMS_COUNT_IS_MAXIMUM_6: "Recipe cant have more than 6 raw materials",
        RECIPE_HAS_TO_HAVE_MINIMUM_1_COATED_AND_MAXIMUM_5_UNCOATED_MATERIALS:
            "Recipe must include at least one coated raw material and up to 5 uncoated materials",
        ONE_OR_MORE_INVALID_MATERIALS_IDS_IN_RECIPE: "One or more invalid raw materials ids in recipe",
        PERCENTAGE_SUM_MUST_BE_100_IN_RECIPE: "Blend percentage must be 100%",
        START_DATE_REQUIRED: "Start date required",
        END_DATE_REQUIRED: "End date required",
        END_DATE_MUST_BE_GRAETER_THEN_START_DATE: "End date must be greater then start date",
        YIELD_VALUE_REQUIRED: "Yield required ",
        COUNTRY_INVALID: "Country invalid",
        CROP_CODE_INVALID: "Crop invalid",
        MESUREMENTS_INVALID: "Mesurment unit invalid",
        SOIL_AND_WATER_COMBINATION_INVALID: "Soil and Water combination invalid",
        MONTHS_AND_TEMPATURES_INVALID: "Months and temperatures values invalid",
        shareWithNoSaving: "sorry, cant share unsaved item",
        ITEM_NAME_TOO_SHORT: "name too short",
        ITEM_RENAME_FAILED: "ITEM_RENAME_FAILED",
        ITEM_DUPLICATE_FAILED: "ITEM_DUPLICATE_FAILED",
        UPDATE_PROFILE_FAILED: "UPDATE_PROFILE_FAILED",
    },
    rightDrawer: {
        showMoreText: "Show",
    },
    fmSummary: {
        shortSummaryTitle1: "Crops",
        shortSummaryTitle2: "Soil",
        shortSummaryTitle3: "Solution",
        shortSummaryTitle4: "Farm",
        shortSummaryTitleGraphPage: "Customize",
        ourProducts: "Our Products",
        summary: "Collected Data",
        seeMoreProducts: "See more Multicote™ products",
        recipeCoatedElements: "Coated elements",
        recipeUncoatedElements: "Uncoated elements",
    },
    fmLeftMenu: {
        title: "MultiMatch",
        subTitle: "Customized plant-nutrition programs",
        menuLabels: {
            label0: "Shlomit Adary",
            label1: "Multicote Agri Solution",
            label2: "Multicote Solution",
            label3: "Saved items",
            label4: "About",
            label5: "Contact us",
        },
        logout: "Log out",
    },
    steps: {
        cropsDesktop: "Crops",
        cropsMobile: "Your crop data",
        soilDesktop: "Soil",
        soilMobile: "Soil Temperatures & Characteristics",
        resultsDesktop: "Results",
        resultsMobile: "Results",
        farmDesktop: "Farm\n(Optional)",
        farmMobile: "Farm practice (Optional)",
        customizeDesktop: "Customize\n(Optional)",
        customizeMobile: "Build your own blend (Optional)",
    },
    agriSolution: {
        title: "Multicote™ Agri Solution",
        selectCropLabel: "Select your crop",
        expectedYieldLabel: "Expected yield",
        plantingDateLabel: "Planting date",
        finalHarvestExpectedDate: "Final harvest expected date",
        selectPlotLocationLabel: "Select plot location",
        selectPlotLocationNote: "Be as specific as possible. This helps to evaluate the climate data",
        selectArea: "or select an area",
        selectOrAddNew: "Select from the list or add new",
        onTheMap: "on the map",
        select: "Select",

        selectSoilLabel: "Soil Temperatures & Characteristics",
        waterRegime: {
            title: "Select water regime",
            description: "What are the areas precipitation conditions?",
            sliderMarks: {
                "1": "Arid",
                "2": "Semi-Aridic",
                "3": "Semi Tropical",
                "4": "Tropical",
            },
        },
        soilType: {
            title: "Specify the soil type in your plot",
            description: "What is the plot’s soil type?",
            sliderMarks: {
                "1": "Sand, loamy sand",
                "2": "Medium sandy",
                "3": "Silt, silty loam, silty clay",
                "4": "Clay loam, clay",
            },
        },
        soilWarning:
            "The nutrient requirement is based on the expected yield. A Multicote fertilizer program is designed to replace all the macro nutrients that the crop will remove. The soil is considered as a buffer and the nutrient content of the soil is not taken into account. It is however a good agricultural practice to take soil samples every 2 to 3 years and to apply the required ameliorants according to the soil analysis. This will ensure that the soil fertility is maintained and improved over time.",
    },
    fmDescriptionSnippet: {
        title: "Welcome to the Multicote solution calculator",
        description:
            "A cloud-based software to create your own customized controlled release fertilizer (CRF) solution for individual or corporate growers in a few easy steps",
    },
    fmDropdownWithImg: {
        title: "Select your crop",
    },
    back: "Back",
    fmRecommendedProduct: {
        volume: "Recommended application volume",
        method: "application method",
        link: "Click to get a release graph",
    },
    pageStep1: {
        soilTemp: "Specify the soil temperature each month",
        change: "Change",
        note: "Please select your crop from the list and enter expected yield, planting date and final harvest date.",
    },
    fertilizationPopup: {
        title: "Fertilizer application rate",
        subTitle: "Data of practiced fertilization rates helps the system calculate nutrient savings and reduction of environmental footprint.",
        thirdTitle: "Select 'I know' below to calculate your new custom formula",
        iKnow: "Enter data and calculate savings",
        iDontKnow: "Data is unavailable",
        next: "Next",
    },
    saveProcessPopup: {
        title: "Save this process",
        subTitle: "We've noticed that you have process not saved, would you like to continued?",
        dontShowThisMessage: "Don’t show this again",
        noThanks: "No, thanks",
        save: "Save",
    },
    clearStepPopup: {
        title: "Clear this step",
        subTitle: "Are you sure you want to clear your data from this step?",
        dontShowThisMessage: "Don’t show this again",
        noGoBack: "Go back",
        clear: "Clear my data",
    },
    deleteItemPopup: {
        title: "Delete item",
        subTitle: "Are you sure you want to delete this item?",
        no: "No",
        yes: "Yes",
    },
    saveItemPopup: {
        title: "Save Solution",
        label1: "Solution name",
        label2: "Area",
        getBack: "I would like a Haifa Agronomist to review my selection and please get back to me.",
        save: "Save",
        snackbar: " Item saved",
    },
    pageStep4: {
        title: "Farm practice",
        table: {
            nutrients: "Nutrients",
            nutrientsUnit: "(Kg/Ha)",
            nutrientsUnitImperial: "(Pound/Acre)",
            label1: "Present (or past) fertilization practice",
            label2: "Crop demand",
            label3: "Present (or past) fertilization practice",
        },
        question: "How do you fertilize today?",
        questionDescription:
            "Optimization of Multicote™ application rates can be based on yor experience. If you already employ fertilization practice that results in suitable yield, please specify the total N-P-K amounts you apply per season.",
        fill: " Fill your practice",
        buttomDescription:
            "Due to the controlled release, Multicote™ enhances nutrient use efficiency. This enables reduction of fertilization rates, thus minimizing  groundwater pollution and soil salinity build-up.",
        warningText1: "We advise to contact a ",
        warningText2: "Haifa Professional Agronomist or Distributor ",
        warningText3: "to confirm your selection before applying.",
        clearThisStep: "Clear this step",
        cfpBanner: "Data of used application rates helps the system calculate carbon and environmental footprint ",
        next: "Next",
        save: "Save",
    },
    multicoteTable: {
        mesurmentUnit: " (%)",
    },
    mainInterests: {
        OFA: "Open field agriculture",
        N: "Nursery",
    },
    metricMethods: {
        "1": "Metric",
        "2": "Imperial",
    },
    specialties: {
        "1": "Gardening \\ hobby",
        "2": "Grower",
        "3": "Agricultural contractor",
        "4": "Farming training \\ services",
        "5": "Trade",
        "6": "Other",
    },
    PageReleaseChart: {
        greenMessage: {
            title1: "HOW TO USE",
            description1: "Always apply Multicote products in the active root zone.",
            description2: "For optimal performance, it should always be covered by a soil or mulch layer.",
            subTitle: "Best practice:",
            description3:
                "Apply 5 cm below the seed at planting. 2nd Best: Spread evenly before cultivation and incorporate into the top 5 to 10 cm of the seedbed.",
            title2: "WHEN",
            description4: " While seeding or at plot preparation, but not more than 2 weeks prior to planting.",
            title3: "HOW MUCH",
            description5: "Multicote technology is safe for use, but for best practice make sure machinery is correctly calibrated.",
            title4: "RELEASE CURVE",
            description6:
                "The release curve displays the nutrients release according to expected soil temperature and the assumption that there will be sufficient moisture, continuously, for diffusion to take place.",
            radioButtonLabel: "Choose a theme: ",
            shareUnsavedItem: "sorry, cant share unsaved item",
        },
        currentDayRemainingReleaseValues: {
            preValue: "Month:",
            postValue: "remaining NPK",
            currentPrecentage: "Remaining NPK (Percentage):",
            Percentage: "(Percentage)",
        },
        sendToAgronomist: {
            preUserName: "The user",
            preCrop: "is planning a solution for the crop",
            preYield: "with expected yield of",
            preStartingDate: "Starting date:",
            preFinalDate: "Final date:",
            preSolutionName: "Solution:",
            materialCode: "Material code:",
            preVolumeApplication: "Volume application:",
        },
        warning: {
            description: "Additional application of secondary and micro elements will be needed. For a complete recommendation, ",
            boldDescription: "contact your local Haifa Agronomist or Distributor",
        },
        buttons: {
            downloadFile: "Download PDF",
            shareLink: {
                desktop: "Share link",
                mobile: "Share",
            },
            sendToPro: "Send to Agronomist",
        },
    },
    wideTable: {
        kodkod: {
            title1: "Material release",
            title2: "by Month (Kg/Ha)",
        },
        sideLabel: {
            label1: "N (var)",
            label2: "P",
            label2_1: "O",
            label3: "K",
        },
        months: {
            month1: "Jan",
            month2: "Feb",
            month3: "Mar",
            month4: "Apr",
            month5: "May",
            month6: "Jun",
            month7: "Jul",
            month8: "Aug",
            month9: "Sep",
            month10: "Oct",
            month11: "Nov",
            month12: "Dec",
        },
        caroselHeader: {
            title: "Monthly Release (%)",
        },
        next: "Next",
        back: "Back",
    },
    saveItemsPage: {
        title: "Saved Solutions",
        inputPlaceholder: "Enter a crop type or an area to find your saved blends",
        mobile_inputPlaceholder: "Enter a crop type or an area",
        clearAll: "Clear all",
        loadMore: "Load more",
        savedItemCard: {
            rename: "Rename",
            delete: "Delete",
            duplicate: "Duplicate",
            contact: "Contact",
            showTo: "Show item to Haifa Agronomist",
        },
    },
    multicoteSolutionPage: {
        stepOne: {
            firstInput: "Select blend",
            secondInput: "Starting Date",
            radioLabel1: "P2O5 K20",
            radioLabel2: "PK",
            selectTemperature: " Select temperature",
            calculateButton: "Calculate",
            setTempratureButton: "Set Temperatures",
        },

        title: "Multicote Solution",
        changeCalculationSetting: "Change calculation setting",
        save: "Save",
        line: "Line",
        bar: "Bar",
        graphCodCodTitle: "Material release",
    },
    pageStep3: {
        carbonFootprintLoadingText: "Please don't close this window",
        carbonFootprintDesc: "Environmental and carbon footprint assessment for the entire crop cycle",
        carbonFootprintButtonText: "Calculate for me!",
        subTitle: "Your recommendation",
        customize: {
            bestSuit: "Recommended formula",
            subDescription: `This formula is the most suitable for your crop’s requirements`,
            title: "Do you want to modify the formula?",
            secondSubDescription: "In a few simple steps, you can customize the formula to meet your preferences",
            button: "Adjust formula",
            topLink: "Release graph",
        },
        bottomTitle: "Ready-made formula",
        bottomDescriptionWithMatch: "This is the ready-made (catalog) formula that is most suitable for recommendations",
        bottomDescriptionWithoutMatch: `We couldn't find a matching formula to suit your crop requirement, soil and climate conditions`,
        recommendedProduct: {
            description:
                "Our recommendation is based on the crop requirement for NPK only, according to the known demand of these nutrients. Secondary and micronutrients applications will be made according to the soil analysis and crop requirements.",
        },
        save: "Save",
        inSoil: "In soil",
        metric: "Kg/Ha",
        imperial: "ST/Acre",
    },
    pageStep5: {
        title: "Build your own blend",
        updateButton: "Update N, P, K Calculation",
        recipeValidationError: "Recipe has to have minimum 1 coated material, maximum 6 item in total",
        save: "Save",
        bestSolution: "Best solution",
        subTitle1: "Select up to 6 Materials in total",
        coated: "Coated",
        uncoated: "Uncoated",
        completePercentage: "Completed percentage of your Multicote blend:",
        missing: "missing",
        clear: "Clear this step",
        continueButton: "Continue to Release chart",
        bottomDrawer: {
            savedItem: " Saved item",
            rename: "Rename",
            delete: "Delete",
            reset: "Reset",
            update: "Update",
        },
        uncoatedHelperText: "",
        updateCard: {
            leftSpan: "N, P, K is calculated by your materials selection:",
            errorMessage: {
                missingWord: "Increase",
                extraWord: "Decrease",
                rightPart: "% for calculation",
            },
        },
    },
    userAreaPage: {
        title: "My Profile",
        tab1: "User Profile",
        tab2: "My raw materials bank",
        inputLabel1: "Full Name",
        inputLabel2: "Country",
        inputLabel3: "E-mail",
        inputLabel4: "Your main interest",
        inputLabel5: "Expertise (Optional)",
        button: "Update",
        inputSecondPage: "Uncoated",
        messages: {
            success: "Profile Updated successfully",
        },
        uncoatedInputHelperText: "",
    },
    contactUs: {
        title: "Have a question? Need to consult?",
        secondTitle: ", thanks for visiting our platform",
        description:
            "We are happy to help with any questions you may have, and would love to hear about your experience so that we can continue improving our offerings.",
        inputLabel1: "Country",
        inputLabel2: "Region",
        inputLabel3: "Position",
        inputLabel4: "Growing method",
        inputLabel5: "Cell phone number",
        inputLabel6: "Area size(ha)",
        inputLabel7: "Email address",
        inputLabel8: "Your message",
        back: "Back",
        send: "Send",
        messages: {
            success: "Thank you for your email. we get back to you soon.",
            invalidPhoneNumber: "Invalid cell phone number",
        },
    },
    PDFfile: {
        mateData: {
            createdBy: "Created by:",
            name: "Name:",
            location: "Location:",
            phoneNumber: "Phone Number:",
            Date: "Date:",
            Time: "Time:",
        },
        summaryData: {
            nutrientsApplied: "Nutrients applied:",
            collectedDataTitle: "Collected data:",
            cropsTitle: "Crops:",
            cropProp: "Crop",
            yieldProp: "Yield",
            plantingDateProp: "Planting date",
            harvestDateProp: "Harvest date",
            soilTitle: "Soil",
            WaterRegimeProp: "Water regime",
            soilProp: "Soil",
            customizedTitle: "Customized",
            recipeCoatedTitle: "Coated Elements",
            recipeUncoatedTitle: "Uncoated Elements",
            recommended: "Recommended",
            MaterialCodeProp: "Material code:",
        },
        waver: {
            title: "WAIVER",
            body: {
                before: "Before using, the grower shall determine the suitability of the product for his intended use.",
                theGrower: "The grower assumes all risk and liability for consequential and incidental damages. This product",
                isSold: "is sold without warranty of any kind, expressed or implied, as to  its merchantability",
                orFitness: " or fitness for a particular purpose.",
                caution: "Caution: ",
                harmful: "Harmful is swallowed. Keep out of reach of children. Store under cool, dry conditions.",
            },
        },
        descriptionRecommended:
            "Our recommendation is based on the crop requirement for NPK only, according to the known demand of these\nnutrients. Secondary and micronutrients applications will be made according to the soil analysis and crop\nrequirements.",
        howToUse: {
            title: "HOW TO USE",
            body: {
                firstLine: "Always apply Multicote products blends at the root zone.",
                secondLine: "For optimal performance, it must be covered with a few centimeters of soil",
                thirdLine: "or mulch.",
                fourthLinePartOne: "Best practice:",
                fourthLinePartTwo: "Apply in row while seeding.",
                fifthLinePartOne: "2nd best:",
                fifthLinePartTwo: "Spread evenly before cultivation and incorporate the Multicote™",
                fifthLinePartThree: "blends into the seedbed.",
                forOptimalPerformance: "For optimal performance, mix Multicote™ with potting soil before planting.",
                mixMulticote: " Mix Multicote™ with potting soil before planting.",
                secondBestPractice: "2nd best practice - Dibbling:",
                forLate: "for late application, make holes around the plant and apply ,Multicote™",
                evenly: "evenly, cover with soil.",
            },
        },
        when: {
            title: "WHEN",
            body: {
                firstLine: "While seeding or at plot preparation, but not more than 2 weeks prior to ",
                secondLine: "planting. ",
            },
        },
        howMuch: {
            title: "HOW MUCH",
            body: {
                firstLine: "Multicote™ technology is safe for use, but for best practice make sure",
                secondLine: "machinery is correctly calibrated.",
            },
        },
        releaseCurve: {
            title: "RELEASE CURVE",
            body: "The release curve displays the nutrients release according to expected soil temperatures",
        },
        nameOfFile: "Multicote™ - Our Solution.pdf",
    },
    ShareEmail: {
        title: "Instructions ",
        body: {
            please: "Please",
            find: "find",
            attached: "attached",
            recommendation: "recommendation",
            Thank: "Thank",
            you: "you",
            Haifa: "Haifa",
            Group: "Group",
        },
    },
    autoCompleteInput: {
        firstSpan: "These values are invalid",
        secondSpan: "max N, P, K is 46, 54, 62",
        thirdSpan: "Max sum is 66",
        noOptions: "No Options",
    },
    sideMenu: {
        termsAndCondition: {
            title: "Terms and Conditions",
            contentTitle: "Terms of use",
            data: 'Welcome to Haifa Group(Haifa Negev technologies Ltd.and its affiliates - "Haifa", "Haifa Group") website("the Website").By using and / or viewing the Website, including the features and services available from it, you are agreeing to comply with and be bound by the following terms of use, along with any additional terms and conditions that are referenced herein or that are presented elsewhere on the Website in relation to a specific service or feature(collectively "Terms of Use").Please review the Terms of Use carefully.If you do not agree to these terms, you should not access this site.The term "Haifa", "Us" or "Our" refers Haifa Chemicals Ltd. , the owner of the Website, and any of its affiliates.The term "you" refers to the user or viewer of our Website.\nBy accessing or using the Website in any way, including, without limitation, use of any of the services or downloading of any Materials, you agree to and are bound by the Terms of Use.You agree that you are at least 18 years of age or the age of majority in your jurisdiction, whichever is older.\nDisclaimer\nThe information contained in the Website is provided on an "as is", "as available" basis.To the fullest extent possible under any applicable law, Haifa makes no representation or warranty as to the accuracy or completeness of information or other warranty of any kind, including any implied warranty of quality, merchantability, fitness for a particular purpose, or non - infringement.In no event shall Haifa be liable to any party for any direct, indirect, incidental, special or consequential damages for use of the Website or reliance upon any information or material accessed via it, or any other hyperlinked website, weather uploaded by Haifa or by any user, including, but not limited to, damages arising from loss of profits, business interruption, or loss of data, even if Haifa is expressly advised about the possibility of such damages, to the fullest extent allowable by law.\nLimitation of liability\nThe use of the Website is at the sole risk of the user.Under no circumstances, shall Haifa or any of its directors, officers, employees, distributors or agents be liable for any direct or indirect losses or damages arising out of or in connection with the access, use, or inability to use the Website or the reliance on any information provided in the Website, included but not limited to Users Content, as defined below, or any third party.Without derogating from the above, Haifa shall not be liable in any way for possible errors or omissions in the contents of the Website.To the fullest extent possible under any applicable law this limitation of liability shall apply to all losses and damages of any kind whatsoever, whether direct or indirect, general, special, incidental, consequential, exemplary or otherwise, including without limitation, loss of data, revenue or profits.This limitation of liability applies whether the alleged liability is based on contract, negligence, tort, strict liability or any other basis and even if an authorized representative of Haifa has been advised of or should have known of the possibility of such damages.\nChanges\n1.Haifa may modify the Terms of Use, or any part thereof, or add or remove terms at any time, and such modifications, additions or deletions will be effective immediately upon posting.Your use of the Website after such posting shall be deemed to constitute acceptance by you of such modifications, additions or deletions. 2.  Haifa may change or discontinue any aspect, service or feature of the Website at any time, including, but not limited to, content, hours of availability, and equipment needed for access or use.\nWebsite Account; Interactive Areas and User Content\n1.You may be given the possibility to register via an online registration form to create a user account(your "Account") that may allow you to receive information from Haifa and / or to participate in certain features on the Website such as certain Interactive Areas.Haifa will use the information you provide in accordance with the Haifa Privacy Policy.By registering, you represent and warrant that all information that you provide on the registration form is current, complete and accurate to the best of your knowledge.You agree to maintain and promptly update your registration information on the Website so that it remains current, complete and accurate.During the registration process, you may be required to choose a password.You acknowledge and agree that Haifa may rely on this password to identify you.You are responsible for all use of your Account, regardless of whether you authorized such access or use, and for ensuring that all use of your Account complies fully with the provisions of these Terms of Use.\n2.Your account, your password and your right to use the Website is not transferable or assignable.Any password or right given to you to obtain information or documents is not transferable or assignable.\n3.The Website may contain comments sections, discussion forums, bulletin boards, or other interactive features("Interactive Areas"") in which you may post or upload comments or user - generated content such as video, photos, messages, other materials or items (collectively, "User Content"). You are solely responsible for your use of any Interactive Areas and you use them at your own risk. By submitting User Content to an Interactive Area, you represent that you are 18 years of age or older or the age of majority in your jurisdiction, whichever is older. \n4. By submitting any User Content or participating in an Interactive Area within or in connection with the Website, you agree not to upload, post or otherwise transmit any User Content that: \n4.1. Violates or infringes in any way upon the rights of others, including any statements which may insult, harass, stalk or threaten others; \n4.2. Violates any law or engage in activity that would constitute a criminal offense or give rise to a civil liability; \n4.3. Advocates or provides instruction on illegal activity or discuss illegal activities with the intent to commit them; \n4.4. Contains advertising or any solicitation with respect to products or services, Unless expressly authorized by Haifa; \n4.5. Contains any User Content protected by copyright, trademark, trade secret, patent, or other proprietary right without the express permission of the owner of such proprietary right. The burden of determining that any User Content is not protected by such proprietary right rests with you. You shall be solely liable for any damage resulting from any infringement of copyrights, trademarks, trade secrets, patents or other proprietary rights or any other harm resulting from such a submission. Any person determined by Haifa, in its sole discretion, to have violated the intellectual property or other rights of others shall be barred from submitting or posting any further material on the Website. \n5.  In addition to the above, by submitting any User Content or participating in an Interactive Area within or in connection with the Website, you agree to the following: 5.1. Not to interfere with any other user\'s right to privacy, including by harvesting or collecting personally-identifiable information about Haifa users or posting private information about a third party;\n5.2. Not to interfere with or disrupt the Website or the servers or networks connected to it, or disobey any requirements, procedures, policies or regulations of networks connected to the Website; \n5.3. Not to upload, post, e - mail or otherwise transmit any unsolicited or unauthorized advertising, promotional materials, "junk mail", "spam", "chain letters", "pyramid schemes", or any other form of solicitation; \n5. 4. Not to reproduce, duplicate, copy, sell, resell or exploit for any commercial purpose, any portion, use or access of the Website. \n6.  Any conduct that in Haifa\'s sole discretion restricts or inhibits anyone else from using or enjoying the Website will not be permitted.  Haifa reserves the right in its sole discretion to remove or edit User Content by you and to terminate your Account for any reason.  Haifa is not responsible for User Content submitted to the Website or posted in comments sections, chat rooms, on bulletin boards or on other Interactive Areas by users of the Website. \n7.  Haifa shall have the right, but not the obligation, to monitor User Content posted or uploaded to the Website to determine compliance with these Terms of Use and any operating rules established by Haifa and to satisfy any law, regulation or authorized government request. Although Haifa has no obligation to monitor, screen, edit or remove any of the User Content posted or uploaded to the Website, Haifa reserves the right, and has absolute discretion, to screen, edit, block access to, refuse to post or remove any User Content posted or uploaded to the Website at any time and for any reason which Haifa may consider to be justified in its sole discretion, including: \n(a) Preventing misuse of any services available on the Website. \n(b) When Haifa deems the User Content to be in breach of these Terms of Use, or an infringement of any applicable law. \n(c) When pursuant to these Terms of Use, the owner of the User Content that you have posted wishes it to be removed, whether as a result of a person\'s complaint, or of Haifa\'s own initiative. \n8.  Haifa do not warrant or guarantee that any User Content that you wish to post on the Website will be posted or that Haifa will post it indefinitely. Haifa may also delete User Content after a certain period of time from initial posting.  Consequently, you might not find User Content that you or any other user previously posted on the Website. \n9.  The Website contains links to content on other websites.  You may find the information and Content posted therein not compatible with your requirements, or you may object to their content, or find such content to be annoying, improper, unlawful or immoral. By linking to a certain website, Haifa do not endorse, or sponsor their content, or confirm their accuracy, credibility, authenticity, validity, integrity or legality. Haifa assumes no responsibility or liability for such third party websites or contents, or their availability. \n10.  Haifa respects the intellectual property rights of others. Any requests to remove copyright infringing content from the Website, or counter requests to repost content, on grounds of mistake or misidentification of the content, shall be made in accordance with the Website’s Copyright Policy. After receiving a request to remove or re - post User Content on the Website, Haifa may act as it deems fit, in accordance with the applicable law. \n11.  Haifa shall not be liable for any direct or indirect losses or damages arising out of or in connection with the screening, editing, refusing to post or removing any User Content, and you are solely responsible for creating backup copies of and replacing any User Content posted to the Site at your sole cost and expense. \n12.  By submitting User Content to the Website, you automatically grant Haifa the royalty - free, perpetual, irrevocable, non - exclusive right and license to use, publish, reproduce, modify, distribute and otherwise exploit such User Content, in whole or in part, in any form, media or technology for the full term of any copyright that may exist in such User Content. You warrant that such User Content is accurate and not misleading, and that use and posting or other transmission of such User Content does not violate these Terms of Use and will not violate any rights of or cause injury to any person or entity. \n13.  User Content submitted by you will be considered non - confidential and Haifa is under no obligation to treat such User Content as proprietary information except pursuant to the Haifa Privacy Policy. \nEquipment\nYou are responsible for obtaining and maintaining all connectivity, computer software, hardware and other equipment needed for access to and use of the Website and all charges related to it. \nIntellectual Property\nThe content, organization, graphics, design, compilation, magnetic translation, digital conversion and other matters related to the Website are protected under applicable copyrights, trademarks, patents and other proprietary(including but not limited to intellectual property) rights. The copying, redistribution, use or publication by you of any such matters or any part of the Site, is strictly prohibited. You do not acquire ownership rights to any content, document or other materials viewed through the Website. The posting of information or materials on the Website does not constitute a waiver of any right in such information and materials. Some of the content on the Website is the copyrighted work of third parties. \nUser Conduct\nIn using the Website, including all services and materials available through it, you agree: not to upload, post, or otherwise transmit through the Website any viruses or other harmful, disruptive, or destructive files; not to create a false identity; not to use or attempt to use another’s account, password, service, or system without authorization from; not to disrupt or interfere with any other user’s enjoyment of the Site or affiliated or linked sites; not to disrupt or interfere with the security of, or otherwise cause harm to, the Website, or any services, materials, system resources, accounts, passwords, servers, or networks connected to or accessible through the Website or any linked sites. \nIndemnification\nYou agree to defend, indemnify and hold harmless Haifa and their respective directors, officers, employees and agents from and against all claims and expenses, including attorneys\' fees, arising out of the use of the Website by you or your Account. \nGoverning Law and Jurisdiction\nBy accessing the Website, you and Haifa agree that all matters relating to your access to, or use of this Website shall be governed by and construed in accordance with the Israeli Law. You irrevocably submit in respect of all matters and disputes arising out of your access to, or use of this Website to the exclusive jurisdiction of the Israeli Courts. \nMiscellaneous\n1.  The Terms of Use and the other rules, guidelines, licenses and disclaimers posted on the Website constitute the entire agreement between Haifa and you with respect to your use of the Website. If for any reason a court of competent jurisdiction finds any provision of these Terms of Use, or portion thereof, to be unenforceable, that provision shall be enforced to the maximum extent permissible so as to effect the intent of the parties as reflected by that provision, and the remainder of the Terms of Use shall continue in full force and effect. Any failure by Haifa to enforce or exercise any provision of these Terms of Use or related right shall not constitute a waiver of that right or provision. \n2.  The section headings used herein are for convenience only and shall not be given any legal import. \n',
        },
        privacyPolicy: {
            title: "Privacy Policy",
            data: 'General Privacy Policy 1. Our Commitment to Privacy Welcome to Haifa Group\'s (Haifa Negev technologies Ltd. and its affiliates - "Haifa", "Haifa Group") website ("the Website"). Protecting your privacy and the personal information you provide us is a top priority for us. For this reason, we do not sell, rent, transfer, assign or provide access to your personal information to third parties for their marketing purposes without your explicit consent. We want our users to fully understand what information we collect, how we use this information, and the steps we take to protect your personal information. Please read this privacy policy to learn more about the policies and procedures we have put in place to achieve this goal. This notice describes our Privacy Policy. By visiting this site, you are accepting the practices described in this Privacy Policy. 2. What Information is Being Collected We collect personal information and non - personal information through the Website.Personal information is information that identifies you as an individual.Non - personal information is aggregated information, IP addresses and any other information that does not reveal your specific identity.2.1.Personal Information - We may collect the following types of personal information: a.Information provided by you when registering to the Website.b.Information provided by you when submitting User content to the Interactive areas(both terms as defined in the Terms of Use of the Website).c.Information you provide us through customer service correspondence and / or general feedback. 2.2.Non - Personal Information - When you visit the Website, we may collect non - personal information, such as a catalog of the Website pages you visit.Non - personal information is generally collected through the Website from the following sources: website analysis software, environmental variables, and other similar technologies and information that you voluntarily provide. 2.3 Information That You Voluntarily Provided - We also collect non - personal information(e.g., your geographic location, etc.) when you voluntarily provide such information to us.When such information is not combined with any personal information, such information is considered to be non - personal information, as it does not personally identify you or any other user.Additionally, we may aggregate personal information in a manner that the end - product does not personally identify you or any other user of the Website.Such aggregate information is considered non - personal information for purposes of this Policy. 3. How and When is the Information Being Used ? Personal Information - We may use personal information we collect in the following ways: a.Fulfillment of Requests.We may use personal information collected about you to provide you with services or information that you request. b.Administrative Communications.From time to time we may use personal information to send to you important information regarding the Website, or changes to our terms, conditions, and policies. c.Other Communications.From time to time, we may use personal information to inform you of products, programs, services and promotions that we believe may be of interest to you and / or to deliver to you our newsletter.Such commercial information and / or newsletter shall be delivered to you only if you opt -in to receive such information. d.Internal Business Purposes.We may also use personal information for our internal business purposes, such as data analysis and audits. 4. The Use of Non - Personal Information Since non - personal information does not personally identify you, we may use such information for any purpose.In addition, we reserve the right to disclose such non personal information to other third parties, for any purpose. 5. Legal Requests We cooperate with law enforcement authorities, as well as with other third parties, to enforce laws, intellectual property rights, and to prevent fraud.In response to a verified request by law enforcement or other government officials relating to a criminal investigation or alleged illegal activity we may disclose your information. 6. We Protect Your Information The privacy and protection of your information is important to us.We will use commercially reasonable efforts to protect your information, continue to assess new technology for protecting your information, and when appropriate, upgrade our information security systems.Subject to the other sections of this Privacy Policy, we do not make any personal information available to third parties without your explicit consent.Please note, however, that no transmission over the Internet or telephone can be fully guaranteed in its confidentiality and non - disclosure, and as such you transmit at your own risk. 7. Consent By using our website, you consent to the collection and use of your personal information as described in this Privacy Policy. 8. Changes to Privacy Policy If our Privacy Policy or procedures change, we will immediately post those changes to the Website.Any such changes will be effective 30 days from the time such new policies are posted, unless otherwise stated in the change.9. Effective Date - This Privacy Policy is effective as of May 2018. Cookies and Online User Experience New regulations change the way in which the use of cookies is governed.This section explains how we use cookies on this Website in order to provide you with the best possible user experience. 1.Your Online Privacy You can visit the Haifa Group website without providing any information about yourself.If you prefer to contact us and provide personal information, we are committed to respect it and to treat it securely and lawfully.We protect your privacy.You may be asked for personal information only as a response to your request, for example while using one of our online contact form or when adding your e - mail address to our mailing list. 2. Cookies – What are They ? Cookies are a short text file which is stored on your computer or other device while visiting a website.Some cookies are deleted when your browser is closed.However, others cookies remain on your device until they expire or you delete them.These cookies enable us to remember things about you and your preferences for your next visits at Haifa Group\'s Website. 3. How to Control or Delete Cookies ? If you want to restrict, block or delete cookies, you can do so through your browser settings.Use The HELP option within your browser to find out all about cookies control.You are also welcome to learn more about cookies at: www.allaboutcookies.org or to use any search engine for seeking independent information about cookies. 4. How do We Use Cookies ? When cookies related to the website are deleted, we will not have records about your previous visits to the website, and you will receive a first - time visitor experience the next time you visit the Haifa Group Website.We use cookies to: a.Present content in the language you set. b.Provide information that is more relevant to you. c.Optimize the online experience. 5. The Analytics Cookies We Use Include: Google Analytics which uses cookies to help get a better understanding how our visitors use the Haifa Group site.Find out more about how these cookies are used on the Google privacy Website.6. Third Party Cookies We may use third - party cookies from marketing partners.These cookies are used to deliver adverts that are most relevant to you and your personal interests.These cookies track your browsing history across third party websites.If you wish to control, prevent or delete this type of cookies, please follow your browser’s cookies settings.Third - party companies we may partner with include: • Facebook • Taboola • Google Search Adwords • Pinterest • LinkedIn • Twitter • Outbrain. For any inquiry you may have, pls contact; info@haifa-group.com',
        },
        copyRightTitle: "Copyright 2021 Haifa",
        poweredBy: "Powered by",
    },
};

export default texts;
